
import Vue from "vue";
import {SaleEditState} from "@/utils/sale-edit/sale-edit-state";
import {roundTo8Decimals} from "@/utils/numbers";
import {ScannerListener} from "@/utils/scanner";
export default Vue.extend({
	data(){
		return {
			value: "",
			numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, ".", 0, "C"]
		};
	},
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		}
	},
	methods: {
		clearValue(){
			this.value = "";
			this.state.productEditRowState.amount = 1;
		},
		handleKeyPress(number: number | string) {
			// Dispatch custom event with the pressed key
			if(number=="C"){
				this.clearValue();
				return;
			}
			this.value += ""+number;
			this.state.productEditRowState.amount = parseFloat(this.value);
			this.$emit("key-pressed", number);
		},
		changeTotal(){
			if(!this.value){
				return;
			}
			this.state.selectedRow.Amount = parseFloat(this.value);
			this.state.selectedRow.Amount1 = parseFloat(this.value);
			this.state.selectedRow.calculateTotals(this.state.sale);
			this.clearValue();
			this.updateRow();
			this.state.sale.calculateTotals();
		},
		retour(){
			if(this.value){
				this.state.selectedRow.Amount = parseFloat(this.value);
				this.state.selectedRow.Amount1 = parseFloat(this.value);
				this.clearValue();
			}
			this.state.selectedRow.Amount *= -1;
			this.state.selectedRow.Amount1 *= -1;
			this.state.selectedRow.calculateTotals(this.state.sale);
			this.updateRow();
			this.state.sale.calculateTotals();
		},
		discount(){
			if(this.state.selectedRow.Discount){
				this.state.selectedRow.Discount = 0;
				this.state.selectedRow.calculateTotals(this.state.sale);
			}else if(this.value){
				this.state.selectedRow.Discount = parseFloat(this.value);
				this.state.selectedRow.calculateTotals(this.state.sale);
				this.clearValue();
			}
			this.updateRow();
			this.state.sale.calculateTotals();
		},
		price(){
			if(this.value){
				this.state.selectedRow.TotalPriceIncVat = parseFloat(this.value);
				this.state.selectedRow.TotalPriceExcVat = parseFloat(this.value)/(1+(this.state.selectedRow.Vat/100));
				this.state.selectedRow.UnitPrice = roundTo8Decimals(
					this.state.selectedRow.TotalPriceExcVat / (this.state.selectedRow.Amount * (1 - this.state.selectedRow.Discount / 100))
				);
				this.state.selectedRow.calculateTotals(this.state.sale);
				this.clearValue();
			}
			this.updateRow();
			this.state.sale.calculateTotals();
		},
		diverse(){
			this.$emit("add-diverse",this.value ? parseFloat(this.value) : 0);
			this.clearValue();
		},
		remove(){
			this.state.removeRow(this.state.selectedRow);
		},
		updateRow(){
			let i = this.state.sale.Rows.indexOf(this.state.selectedRow);
			this.state.sale.Rows.splice(i + 1, 0, ...this.state.createCompositionRows(this.state.selectedRow));
			this.$emit("store");
		},
		async onScannerInput(input:string){
			await this.scan(input);
		},
		async scan(input:string){
			let product = undefined;
			try{
				product = await this.state.searchProduct(input);
			}catch(err){
				await this.$wf.dialog(this.$ct("components.sales.Cashier.warning-sku-not-found"), this.$ct("common.ok"), this.$ct("common.error"), "warning");
			}
			let amount = 1;
			if(parseFloat(this.value)>0){
				amount = parseFloat(this.value);
			}
			if(product !== undefined){
				for (let row of this.state.sale.Rows) {
					if (row.ProductSku == product.Sku && (row.SizeTableEntryID ?? null) == (product.MatchedSizeTableEntryID ?? null)) {
						row.Amount1 = row.Amount1+amount;
						row.Amount = this.state.dossierConfig?.UseAmount2AsMultiplier !== false ? row.Amount1 * row.Amount2 : row.Amount1;
						for (let c of product.Composition) {
							for (let r of this.state.sale.Rows) {
								if (r.ProductSku == c.ProductSku && r.ProductDescription == c.ProductDescription) {
									r.Amount1 += c.Amount;
									r.Amount = this.state.dossierConfig?.UseAmount2AsMultiplier !== false ? r.Amount1 * r.Amount2 : r.Amount1;
								}
							}
						}
						this.state.sale.calculateTotals();
						this.clearValue();
						return;
					}
				}
				this.state.productEditRowState.amount = amount;
				this.state.addMultipleProducts([product]);
				this.state.sale.calculateTotals();
				this.clearValue();
			}
		}
	},
	mounted(){
		ScannerListener.onInput(this.onScannerInput);
		this.state.on("product-added", this.clearValue);
	},
	destroyed(){
		ScannerListener.offInput(this.onScannerInput);
		this.state.off("product-added", this.clearValue);
	},
});
